export const businessLineToRoute = {
  WOMENS: 'women',
  MENS: 'men',
  KIDS: 'kids',
  SHELL: 'shell',
};
